
































































































































































import { QuestionnaireDetail } from '@/composable/questionnaire/useQuestionnaireDetail'
import { isQuestionnaireOnlyName } from '@/types/receipt'
import { prefectures } from '@/utils/prefectures'
import { computed, defineComponent } from '@vue/composition-api'

type Props = {
  questionnaire: QuestionnaireDetail
  isAutomatic: boolean
}

export default defineComponent<Props>({
  name: 'QuestionDetailTable',
  props: {
    questionnaire: {
      type: Object,
      required: true,
    },
    isAutomatic: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props) {
    const shouldShowFixedUrl = computed(() => {
      if (props.questionnaire.targetSupplier === null) {
        return false
      }
      return isQuestionnaireOnlyName(props.questionnaire.targetSupplier)
    })

    const sortedPrefecture = computed(() => {
      return prefectures
        .flatMap(p => p.children)
        .flatMap(p => p.children || [])
        .map(p => p.name)
        .filter(p => props.questionnaire.targetPrefecture.includes(p))
        .join(', ')
    })

    const copyUrl = () => {
      if (window.navigator.clipboard === undefined) {
        return
      }
      window.navigator.clipboard.writeText(
        props.questionnaire.fixedQuestionnaireUrl || '',
      )
    }

    return { shouldShowFixedUrl, sortedPrefecture, copyUrl }
  },
})
